export default `
  fragment QuoteFragment on Quote {
    id
    name
    type
    data
    meta
    status
  }
`;
